import { v2 } from '.'

export const getOverview = searchParams => v2.get('invitation/return/overview', { searchParams }).json()
export const invitationList = json => v2.post('invitation/friend/list', { json, ignoreSuccessMessage: 1 }).json() // 邀请记录
export const rebateList = json => v2.post('invitation/return/list', { json, ignoreSuccessMessage: 1 }).json() // 返佣记录
